import { Text } from '@react-three/drei'

import { socialsButtons } from '../data.js'

import Panel from './Panel'
import Pill from './Pill'
import FlatTextClickable from './FlatTextClickable'

export default function SocialsPanel() {
  const fontSize = 0.05
  const lineHeight = 1
  const buttonWidth = 0.25
  const buttonsWidth = buttonWidth * socialsButtons.length

  const clickCallback = (e) => window.open(e.object.userData.link, '_blank')

  return (
    <>
      <Panel size={[buttonsWidth + 0.1, 0.2]}></Panel>
      {socialsButtons.map((btn, i) => (
        <group key={`pill-${i}`}>
          <Pill
            width={buttonWidth}
            height={fontSize * 2}
            position={[-(buttonsWidth * 0.5) + 0.125 + buttonWidth * i, 0, 0.03]}
          />
          <FlatTextClickable
            renderOrder={10}
            clickCallback={clickCallback}
            children={btn.description}
            userData={{ link: btn.link }}
            position={[-(buttonsWidth * 0.5) + 0.125 + buttonWidth * i, 0, 0.021]}
            fontSize={fontSize}
            lineHeight={lineHeight}
            letterSpacing={-0.05}
            anchorX={'center'}
            anchorY={'middle'}
            materialToneMapped={false}
          />
        </group>
      ))}
      <Text
        renderOrder={10}
        children={`Copyright © 2024 Inovise Inc. All rights reserved.`}
        position={[0, -0.15, 0.002]}
        fontSize={fontSize}
        lineHeight={lineHeight}
        letterSpacing={-0.05}
        anchorX={'center'}
        anchorY={'middle'}
        materialToneMapped={false}
      />
    </>
  )
}
